import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function PublicLayout({ children }) {
    return (
        <div className="public-site min-h-screen flex flex-col bg-white text-[#0A0A0A]">
            <Navbar />
            <main className="flex-1 pt-20">{children}</main>
            <Footer />
        </div>
    );
}
